module.exports = __webpack_public_path__ + "img/20200122132237070.093081c1.jpg";